<template>
  <div class="app_fun_cla">
    <div class="app_go_back">
      <div class="goBack" @click="goBack">
        <i class="goback-icon-cla"></i>
        <span>{{ $t('developer.goback') }}</span>
      </div>
    </div>

    <zkThreeRow>
      <div slot="search">
        <el-form :model="form" :inline="true">
          <el-form-item label="">
            <el-select
              v-model="form.type"
              placehol
              :placeholder="$t('common.chooseOptions')"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="form.value"
              :placeholder="$t('common.inputKeyWord')"
            >
              <template slot="append">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="onSearch"
                ></el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table" class="app_list_cla">
        <template v-if="accoutList.length !== 0">
          <div style="cursor: pointer;text-align:right;margin:10px">
            <el-checkbox
              v-model="isCheckAllAccountBool"
              @change="isCheckAllAccount"
              >{{ $t('operation.checkAll') }}
            </el-checkbox>
          </div>

          <el-collapse v-model="activeName">
            <template v-for="item in accoutList">
              <el-collapse-item
                :name="item.loginName"
                :key="item.id"
                class="collapse-item-cla"
              >
                <template slot="title">
                  <span class="collapse-block-cla"></span>
                  <el-checkbox
                    :indeterminate="item.indeterminate"
                    v-model="item.isCheckAll"
                    @change="handleCheckAllChange(item)"
                    :disabled="item.dbsAppInfoList.length === 0"
                  >
                    <span style="margin-left:15px">{{ item.loginName }}</span>
                  </el-checkbox>
                </template>
                <div class="app_wrapper_cla">
                  <template v-if="item.dbsAppInfoList.length !== 0">
                    <template v-for="app in item.dbsAppInfoList">
                      <div :key="app.id" class="app_item_cla">
                        <div class="app_item_title">
                          <span
                            style="overflow:hidden;white-space: nowrap;text-overflow: ellipsis;"
                            >{{ app.appName }}</span
                          >
                          <span>
                            <el-checkbox
                              v-model="app.isCheck"
                              @change="checkedEvent(item)"
                            ></el-checkbox
                          ></span>
                        </div>
                        <div class="app_item_app_key">
                          AppKey：{{ app.appKey }}
                        </div>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    {{ $t('common.noData') }}
                  </template>
                </div>
              </el-collapse-item>
            </template>
          </el-collapse>
          <el-row v-if="listOver" class="load-more-cla">
            <el-button
              @click="loadMore"
              :loading="loading"
              class="load-more-btn-cla"
              type="text"
              >{{ $t('com_log.loadMore') }}</el-button
            >
          </el-row>
          <el-row>
            <el-col align="center">
              <el-button
                type="primary"
                @click="saveAppFnSetting"
                style="margin-top:15px"
                >{{ $t('operation.save') }}</el-button
              >
            </el-col>
          </el-row>
        </template>
        <zkNoData v-else></zkNoData>
      </div>
    </zkThreeRow>
  </div>
</template>

<script>
import {
  updateAppConfigAccount,
  getAppConfigAccountList
} from '@/services/appManagerApi.js'
let orginAccountList = []
export default {
  data() {
    return {
      form: {
        type: 0,
        value: ''
      },
      options: [
        {
          label: this.$t('developer.appName'),
          value: 0,
          attr: 'appName'
        },
        {
          label: 'AppKey',
          value: 1,
          attr: 'appKey'
        },
        {
          label: this.$t('developer.developerAccount'),
          value: 2,
          attr: 'loginName'
        }
      ],
      activeNames: 1,
      accoutList: [],
      listOver: true,
      loading: false,
      loadingInstance: null,
      pagers: {
        showNext: false,
        pNum: 1,
        pTotal: 0,
        pSize: 20
      },
      isCheckAllAccountBool: false,
      isUpdate: false
    }
  },
  methods: {
    isCheckAllAccount(val) {
      this.accoutList.forEach(item => {
        let res = item.dbsAppInfoList
        if (res.length === 0) {
          return
        }

        item.isCheckAll = val
        item.indeterminate = val ? !val : false
        res.forEach(o => {
          o.isCheck = val
        })
      })
    },
    onSearch() {
      this.pagers.pNum = 1
      this.accoutList = []
      orginAccountList = []
      this.getAccountList()
    },
    loadMore() {
      if (this.pagers.showNext) {
        this.isCheckAllAccountBool = false
        this.pagers.pNum = this.pagers.pNum + 1
        this.showLoad()
        this.getAccountList()
      } else {
        return false
      }
    },

    saveAppFnSetting() {
      this.showLoad(this.$t('operation.saving'))
      let data = this.filterStatusChange()
      let params = {
        list: data
      }
      updateAppConfigAccount(params)
        .then(data => {
          if (data.code === '00000000') {
            this.closeLoad()
            this.successMessage(this.$t('successOperation.update'))
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => this.errorMessage())
        .finally(() => {
          this.closeLoad()
        })
    },
    filterStatusChange() {
      let result = []
      this.accoutList.forEach(item => {
        let dbsInfoList = item.dbsAppInfoList
        dbsInfoList.forEach(k => {
          if (k.isCheck) {
            result.push(k)
          }
        })
      })
      return result
    },
    checkedEvent(item) {
      let appInfoList = item.dbsAppInfoList
      let len = item.dbsAppInfoList.length
      let result = appInfoList.filter(e => {
        if (e.isCheck) {
          return e
        }
      })
      let checkedLen = result.length
      if (len === checkedLen) {
        item.isCheckAll = true
        item.indeterminate = false
      } else if (checkedLen !== 0 && checkedLen < len) {
        item.isCheckAll = false
        item.indeterminate = true
      } else if (checkedLen === 0) {
        item.isCheckAll = false
        item.indeterminate = false
      }
    },
    handleCheckAllChange(item) {
      let appList = item.dbsAppInfoList
      if (item.isCheckAll) {
        appList.forEach(app => {
          app.isCheck = true
        })
        item.indeterminate = false
      } else {
        appList.forEach(app => {
          app.isCheck = false
        })
        item.indeterminate = false
      }
    },
    goBack() {
      this.$router.push({
        path: '/appManager/configSetting'
      })
    },
    getAccountList() {
      this.showLoad()
      let params = { ...this.pagers }
      this.options.forEach(item => {
        if (item.value === this.form.type) {
          params[item.attr] = this.form.value
        }
      })

      getAppConfigAccountList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.accoutList.push(...data.payload.results.list)

            orginAccountList.push(
              ...JSON.parse(JSON.stringify(data.payload.results.list))
            )
            this.pagers.showNext = data.payload.results.showNext

            if (this.pagers.showNext) {
              this.listOver = true
            } else {
              this.listOver = false
            }
          } else {
            this.errorMessage(data.message)
          }
          try {
            this.loading = false
          } catch (error) {}
        })
        .catch(e => {
          this.loading = false
          this.errorMessage()
        })
        .finally(() => {
          this.closeLoad()
        })
    }
  },

  mounted() {
    this.getAccountList()
  }
}
</script>

<style scoped lang="less">
@import '~@/styles/var.less';
.app_fun_cla {
  .app_go_back {
    position: relative;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 2px;
    box-shadow: @boxShadow;
  }
  .app_list_cla {
    /deep/ .el-checkbox__inner {
      border-radius: 50%;
    }
    .app_wrapper_cla {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .app_item_cla {
      width: 300px;
      margin: 0 10px 10px 0;
      border: 1px solid @fontColor4;
      border-radius: 4px;
      line-height: 28px;
      padding: 10px;
      box-shadow: @boxShadow;
    }
    .app_item_title {
      white-space: nowrap;
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 700;
    }
    .app_item_app_key {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: @fontColor3;
    }
  }
  .load-more-cla {
    padding: 5px;
    text-align: center;
    .load-more-btn-cla {
      color: #909399;
      :hover {
        color: #7ace43;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/appFunSetting.vue